import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { useNavConfig } from 'config'
import { logEvent } from 'lib/analytics'

import { selectIsLoggedIn } from 'store/selectors'

import usePageModal from 'features/Modal/hooks/usePageModal'

import Button from 'components/Button'
import LanguageDropdown from 'components/LanguageDropdown'
import { MODAL_MODE } from 'components/Modal/config'
import Navigation from 'components/Navigation'

import { HeaderSearch } from '../HeaderSearch'
import { UserMenu } from '../UserMenu'
import { HeaderTitle } from '../YayHeaderTitle'

import './style.scss'

const DesktopHeader = ({ isLandingPage = false }) => {
  const { t } = useTranslation()
  const { open } = usePageModal()

  const isLoggedIn = useSelector(selectIsLoggedIn)

  const menu = useNavConfig({ isLoggedIn })

  return (
    <nav className="DesktopHeader">
      <HeaderTitle isLandingPage={isLandingPage} />

      <HeaderSearch />

      <Navigation menu={menu} isLandingPage={isLandingPage} />

      {!isLoggedIn && (
        <>
          <LanguageDropdown isLandingPage={isLandingPage} />

          <div className="DesktopHeader__login-buttons">
            <Button
              data-test-id="login"
              buttonStyle={isLandingPage ? 'bordered-white' : 'bordered-gray'}
              size="medium"
              onClick={() => {
                open(MODAL_MODE.LOGIN)
                logEvent.navigation_pane_select({ destination: 'Login' })
              }}
            >
              {t('common.login')}
            </Button>

            <Button
              data-test-id="sign_up"
              size="medium"
              onClick={() => {
                open(MODAL_MODE.SIGN_UP)
                logEvent.navigation_pane_select({ destination: 'Sign Up' })
              }}
            >
              {t('common.sign_up')}
            </Button>
          </div>
        </>
      )}

      {isLoggedIn && <UserMenu />}
    </nav>
  )
}

export default DesktopHeader
